<!-- 人员管理 -->
<template>
    <div class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="人员管理" name="first">
				<div class="basis-page-cls">
					<section class="basis-cls_filter">
						<table-search :filterHeader="filterHeader" :defaultQuery="queryInfo" @filterSearch="filterSearch" />
					</section>

					<section class="basis-cls_table">
						<div class="header">
							<span class="title el-icon-document"> 人员列表</span>
							<div class="btns">
								<el-dropdown size="small" split-button type="primary" style="margin-right: 10px;">
									<el-upload
										:http-request="httpRequestFile"
										:show-file-list="false"
										accept=".xlsx, .xls"
										action="">
										<span style="color: #ffffff;">批量上传</span>
									</el-upload>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item>
											<a :href="`${cdnUrl}/static/excel/cn_batch_import_user_template.xlsx`" style="margin-left: 10px;color: #337EFF;" download="模板.xlsx"><i class="el-icon-download"></i>中文模板</a>
										</el-dropdown-item>
										<el-dropdown-item>
											<a :href="`${cdnUrl}/static/excel/en_batch_import_user_template.xlsx`" style="margin-left: 10px;color: #337EFF;" download="Template.xlsx"><i class="el-icon-download"></i>英文模板</a>
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>

								<el-button type="primary" icon="el-icon-plus" size="small" @click="showAddUser()">新增</el-button>
							</div>

						</div>
						<div class="table">
							<table-pagination
								pagination
								:data="userList"
								:column="column"
								:total="total"
								:page.sync="queryInfo.pageNum"
								:limit.sync="queryInfo.pageSize"
								@pagination="getManageSelec" />
						</div>
					</section>
				</div>
			</el-tab-pane>
			<el-tab-pane label="群组管理" name="second">
				<Group />
			</el-tab-pane>
		</el-tabs>

        <!--人员批量上传处理-->
        <el-dialog append-to-body title="提示" :modal-append-to-body="false" width="450px" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="fileBliong">
            <div class="fileBox">
                <p v-for="(item, index) in fileArr" :key="index"><span>{{index + 1}}</span> {{item}}</p>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="fileBliong = false">取 消</el-button>
            </div>
        </el-dialog>

        <userAuth ref="userAuth"/>
        <userUpdate ref="userUpdate" @requestList="getManageSelec"/>
    </div>
</template>

<script>
    import Group from './group';
    import { mapGetters } from 'vuex';

    import userAuth from "./components/userAuth";
    import userUpdate from "./components/userUpdate";

    export default {
        components: {
            userAuth,
            userUpdate,
			Group
        },
        data() {
            return {
				cdnUrl: process.env.VUE_APP_BASE_CDN,
				activeName: 'first',
                // 列表数据
                column: [
                    { 
                        label: '品牌', 
                        prop: 'brandIdentify', 
                        minWidth: 120 
                    },
                    { label: '用户名', prop: 'account', minWidth: 120 },
                    { label: '昵称', prop: 'nickname', minWidth: 150 },
                    { label: '电话工号', prop: 'agentCode', minWidth: 180 },
                    { label: '创建时间', prop: 'createTime', minWidth: 180 },
                    { 
                        label: '用户类型', 
                        minWidth: 180,
                        render: (h, scope) => {
                            return (
                                <span>
                                    {this.getUserType(scope.row.userType)}
                                </span>
                            )
                        }
                    },
                    { 
                        label: '踢人/解锁', 
                        minWidth: 180,
                        render: (h, scope) => {
                            return <span>
                                {
                                    scope.row.tempLocked == 1 &&
                                    <el-tooltip class="item" effect="dark" content="解锁帐户" placement="right">
                                        <span>
                                            <svg-icon onClick={()=>this.unlockUser(scope.row.userId)} icon-class="lock2" style="margin-left: 9px; cursor:pointer;" />
                                        </span>
                                    </el-tooltip>
                                }
                                {
                                    (scope.row.tempLocked == 1 && scope.row.isOnline) &&
                                    <el-divider direction="vertical"></el-divider>
                                }
                                {
                                    scope.row.isOnline && 
                                    <el-button type="text" onClick={()=>this.forceCheckout(scope.row.userId)}>强制下线</el-button>
                                }
                            </span>
                        } 
                    },
                    {
                        label: '操作',
                        prop: 'cation',
                        align: 'center',
                        width: 180,
                        fixed: 'right',
                        render: (h, scope) => {
                            return (
                                <div>
                                    <el-button 
                                        onClick={() => this.editUser(scope.row)}
                                        type="text">
                                        修改
                                    </el-button>
                                    <el-button 
                                        onClick={() => this.auth(scope.row)}
                                        type="text">
                                        独立授权
                                    </el-button>
                                    <el-button 
                                        onClick={() => this.delUser(scope.row)}
                                        type="text">
                                        删除
                                    </el-button>
                                </div>
                            )
                        }
                    }
                ],
                // ------------------------------------------------------------
                // 表头数据
                filterHeader: [
                    { 
                        label: '所属品牌', 
                        model: 'prantBrand', 
                        type: 'select', 
                        labelName: 'brandName', 
                        valueName: 'brandIdentify', 
                        default: '', 
                        list: [],
                        placeholder: '请选择品牌' 
                    },
                    { 
                        label: '子品牌', 
                        model: 'sonBrand', 
                        type: 'select', 
                        labelName: 'brandName', 
                        valueName: 'brandIdentify', 
                        multiple: true, 
                        default: [], 
                        list: [],  
                        placeholder:'请选择子品牌' 
                    },
                    {
                        label: '登录账号', 
                        model: 'account', 
                        type: 'input', 
                        default: '', 
                        placeholder: '请输入登录名' 
                    },
                    { 
                        label: '角色', 
                        model: 'roleId', 
                        type: 'select', 
                        labelName: 'roleName',
                        valueName: 'roleId',
                        multiple: true, 
                        default: [], 
                        list: [], 
                        placeholder: '请选择角色' 
                    },
                    { 
                        label: '昵称', 
                        model: 'nickname', 
                        type: 'input', 
                        default: '', 
                        placeholder: '请输入昵称' 
                    },
                    { 
                        label: '创建时间', 
                        model: 'datePicker', 
                        type: 'datetimerange', 
                        default: '' 
                    }
                ],
                queryInfo: {
                    pageNum: 1,
                    pageSize: 10,
                    prantBrand: '',
                    sonBrand: [],
                    roleId: [], // 选中的角色项
                    account: "",
                    nickname: "",
                    datePicker: "",
                    brandIdentify: '',
                    ect: "",
                    sct: ""
                },
                total: 0,
                // --------------------------------
                fileArr: [],
                fileBliong: false,
              
                // 分页后的列表数据
                list: [],
                // 在线用户ID
                onlineUsers: [],
                // 在线用户list 表格中的数据
                userList: [],
            }
        },
        computed: {
            ...mapGetters([
                'userInfo',
                'subBrandList',
                'channelList'
            ])
        },
        watch: {
            list: {
                handler(newData, oldData) {
                    this.setOnlineState();
                },
                immediate: true,
                deep: true
            },
            onlineUsers: {
                handler(newData, oldData){
                    this.setOnlineState();
                },
                immediate: true,
                deep: true
            },
            "queryInfo.prantBrand": {
            	handler(newData, oldData){
            		this.refreshBrandSelect();
            		this.refreshRoleSelect();
            	}
            }
        },
        creat(){

        },
        mounted() {
            this.queryInfo.prantBrand = this.userInfo.brandIdentify
            this.getManageSelec()
            this.getRoleListBtn()
            this.getBrandListBtn()
            this.sonGetBrandListBtn()
            this.userCommonOnline();
        },
        methods: {
            filterSearch(){
                this.getManageSelec();
            },
            // 解锁用户帐号
            unlockUser(userId){
                this.$confirm('是否解锁该用户', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    // type: 'error',
                }).then(() => {
                    this.$api.userCommonUnlock(userId).then((res)=>{
                        this.$message({
                            type: 'success',
                            message: '解锁成功!'
                        });
                        this.getManageSelec(); 
                    })
                })
            },
            // 强制签出
            forceCheckout(userId) {
                this.$confirm('强制下线后，用户将退出登录，请确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    // type: 'error',
                }).then(() => {
                    this.$api.userCommonForceCheckout(userId).then((res)=>{
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        })
                        this.userCommonOnline();
                    })
                })
            },
            // 获取用户在线状态 
            userCommonOnline(){
                this.$api.userCommonOnline().then(res=>{
                    this.onlineUsers = res.data;
                })
            },
            // 修改用户列表在线状态
            setOnlineState(){
                this.userList = this.list;
                for(let userData of this.userList){
                    userData.isOnline = this.onlineUsers.includes(userData.userId);
                }
                this.userList = [...this.userList];
            },
            // 通过遍号获取用户类型
            getUserType(index){
               const userType = ["普通用户","管理员(仅限Majorel内部使用)","品牌管理员"]; 
               return userType[parseInt(index)];
            },

            // 批量导入
            httpRequestFile (file) {
                const formData = new FormData();
                formData.append('file', file.file);
                this.$api.userMangeImport(formData).then(res => {
                    this.fileArr = res.data.fail
                    if(res.errcode == 0 && res.data.fail.length <= 0) {
                        this.$message.success(res.errmsg);
                        this.getManageSelec()
                    } else {
                        this.fileBliong = true
                    }
                });
            },

            // 显示授权
            auth(param) {
                this.$refs.userAuth.open(param);
            },
            showAddUser() {
                this.$refs.userUpdate.showAddUser();
            },
            // 刷新子品牌下拉
            refreshBrandSelect() {
                this.queryInfo.sonBrand = [];
                this.sonGetBrandListBtn();
            },
            // 刷新角色下拉
            refreshRoleSelect(value) {
            	this.queryInfo.roleId = [];
        		this.getRoleListBtn();
            },
            // 获取品牌下拉项
            getBrandListBtn(brandName) {
                this.$api.getBrandSelist({
                    data: {
                        // brandIdentify: this.queryInfo.brandIdentify,
                        // brandName: brandName
                    },
                    orderBy: '',
                    pageNum: 1,
                    pageSize: 50
                }).then(res => {
                    this.filterHeader[0]['list'] = res.list;
                })
            },
            // 获取子品牌下拉项
            sonGetBrandListBtn() {
                this.$api.getBrandSelist({
                    data: {
                        // brandIdentify: this.queryInfo.brandIdentify,
                        // brandName: this.queryInfo.brandName,
                        parentBrandIdentify: this.queryInfo.prantBrand || ""
                    },
                    orderBy: '',
                    pageNum: 1,
                    pageSize: 50
                }).then(res => {
                    this.filterHeader[1]['list'] = res.list;
                    this.sonBrandOptions = res.list
                })
            },
            // 获取角色下拉项
            getRoleListBtn() {
                this.$api.getRoleList({
                    data: {
                    	brandIdentify: this.queryInfo.prantBrand || "",
                        assistantResId: "",
                        brandId: "",
                        createBy: "",
                        createTime: "",
                        createTimeFrom: "",
                        createTimeTo: "",
                        description: "",
                        isSelect: "",
                        parentRoleId: "",
                        roleId: "",
                        roleName: "",
                        state: ""
                    },
                    orderBy: '',
                    pageNum: 1,
                    pageSize: 50
                }).then(res => {
                    this.filterHeader[3]['list'] = res.list;
                })
            },

            // 获取人员列表数据
            getManageSelec() {
                this.$api.getManageSel({
                    data: {
                        roleList: this.queryInfo.roleId,
                        account: this.queryInfo.account,
                        agentCode: null,
                        createTimeFrom: this.queryInfo.datePicker ? this.queryInfo.datePicker[0] : '',
                        createTimeTo: this.queryInfo.datePicker ? this.queryInfo.datePicker[1] : '',
                        nickname: this.queryInfo.nickname,
                        userType: '',
                        brandIdentify: this.queryInfo.prantBrand ? this.queryInfo.prantBrand : this.userInfo.userType == 1?"":this.userInfo.brandIdentify,
                        brandList: this.queryInfo.sonBrand,
                    },
                    orderBy: null,
                    pageNum: this.queryInfo.pageNum,
                    pageSize: this.queryInfo.pageSize
                }).then(res => {
                    let code = res.errcode
                    if (code == 0) {
                        this.list = res.list

                        this.total = res.total
                    }
                }).catch(() => {
                })
            },
            // 新建用户
            showAddUser() {
                this.$refs.userUpdate.showAddUser(this.queryInfo.prantBrand);
            }, 
            // 修改用户
            editUser(param) {
                this.$refs.userUpdate.editUser(param);
            },
            delUser(userData) {
                this.$confirm(`是否删除用户"${userData.account}"？用户一经删除，将无法恢复。`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.$api.getUserDelm(userData.userId).then(res => {
                        if(res.errcode != 0) return false;
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getManageSelec();
                    })
                }).catch(() => {
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
.page {
	padding: 0 20px;
	box-sizing: border-box;
}
    .el-table ::v-deep .hiddenAll .cell .el-checkbox__inner {
        margin-left: -30px;
        position: relative;
    }

    .el-table ::v-deep .hiddenAll .cell:before {
        position: absolute;
        content: "权限";
        right: 65px;
    }
    .fileBox {
        max-height: 450px;
        overflow: auto;
        p {
            padding: 5px 0;
            span {
                padding: 2px 6px;
                background: #337EFF;
                border-radius: 50%;
                color: #fff;
            }
        }
    }

</style>
